/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */

export default {
  users: [],
  gbdata:[]
}
